import { useState } from 'react';

import { EnvironmentId } from '@/react/portainer/environments/types';

import { Badge, BadgeType } from '@@/Badge';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { TrivySeverity } from '../../types';

import { FindingsSummary } from './FindingsSummary';

export function CountBadge({
  environmentId,
  namespace,
  workload,
  resourceKind,
  container,
  severity,
  type,
  label,
  count,
}: {
  environmentId: EnvironmentId;
  namespace: string;
  workload: string;
  resourceKind: string;
  container: string;
  severity: TrivySeverity;
  type: BadgeType;
  label: string;
  count: number;
}) {
  // The list is built from projected counts, so CVE detail is fetched for one
  // workload on demand rather than pulling every finding for every row upfront.
  const [hasHovered, setHasHovered] = useState(false);

  if (count === 0) {
    return null;
  }

  return (
    <span
      onMouseEnter={() => setHasHovered(true)}
      onFocus={() => setHasHovered(true)}
    >
      <TooltipWithChildren
        focusable
        position="top"
        heading={`${label} (${count})`}
        message={
          <FindingsSummary
            environmentId={environmentId}
            namespace={namespace}
            workload={workload}
            resourceKind={resourceKind}
            container={container}
            severity={severity}
            label={label}
            total={count}
            enabled={hasHovered}
          />
        }
      >
        <span aria-label={`${label}: ${count}. Show the worst findings.`}>
          <Badge type={type}>
            {label.charAt(0)} {count}
          </Badge>
        </span>
      </TooltipWithChildren>
    </span>
  );
}
